import { render, staticRenderFns } from "./MessageDisplay.vue?vue&type=template&id=eb6ec4fa&scoped=true&"
import script from "./MessageDisplay.vue?vue&type=script&lang=js&"
export * from "./MessageDisplay.vue?vue&type=script&lang=js&"
import style0 from "./MessageDisplay.vue?vue&type=style&index=0&id=eb6ec4fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb6ec4fa",
  null
  
)

export default component.exports